import React from 'react';
import AppRouter from './router';
import './styles/main.css';
import AuthProvider from '@/modules/Auth/AuthProvider';
import { createCacheConfig } from '@/modules/Auth/index';
import { authConfig, authEventHandlers } from './config';
import { createTheme, ThemeProvider } from '@mui/material/styles';


//Date Picker Imports
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import { ConfirmationServiceProvider } from '@components/ConfirmDialog/ConfirmationService';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { ErrorFallbackPage } from '@pages/ErrorFallbackPage';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
import EnvRibbon from '@components/EnvRibbon';

const mmmTheme = createTheme({
  palette: {
    primary: {
      main: '#ffcc00ff',
    },
    secondary: {
      main: '#191919ff',
    },
  },
});

dayjs.extend(utc);
dayjs.extend(timezone);
const B2C_SCOPE = import.meta.env.VITE_MMP_API_SCOPE;
const queryClient = new QueryClient();
export const AI_CONNECTION_STRING = import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING;

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();


export const appInsights = new ApplicationInsights({
  config: {
    connectionString: AI_CONNECTION_STRING,
    // @ts-ignore
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    enableAjaxErrorStatusText: true,
    isBrowserLinkTrackingEnabled: true,
    enableAjaxPerfTracking: true,
    correlationHeaderExcludedDomains: ['*.queue.core.windows.net'],
    loggingLevelConsole: 2,
    loggingLevelTelemetry: 2,
    namePrefix: 'ai-ecs-sm-basic-shared',
    maxBatchInterval: 0,
    disableFetchTracking: false,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    }
  }
});
if(!!AI_CONNECTION_STRING) {
  appInsights.loadAppInsights();
} else {
  console.error('TELEMETRY: No connection string found');
}

const authenticationRequestProps = {
  scopes: [import.meta.env.VITE_CLIENT_ID, 'openid', 'offline_access'],
  redirectUri: import.meta.env.VITE_REDIRECT_URL,
};
const authConfigProps = {
  ...authConfig,
  ...createCacheConfig({
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  }),
};


export default function App() {
  return (
    <AuthProvider customEvents={authEventHandlers} authConfig={authConfigProps}>
      <MsalAuthenticationTemplate authenticationRequest={authenticationRequestProps} interactionType={InteractionType.Redirect}>
        <ThemeProvider theme={mmmTheme}>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ConfirmationServiceProvider>
                <EnvRibbon />
                {!!AI_CONNECTION_STRING ? <AppInsightsErrorBoundary onError={() => <ErrorFallbackPage />} appInsights={reactPlugin}>
                  <AppRouter />
                </AppInsightsErrorBoundary> :
                  <AppRouter />}
              </ConfirmationServiceProvider>
            </LocalizationProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </MsalAuthenticationTemplate>
    </AuthProvider>
  );
}
